'use strict';

routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_1dn4f012xl = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/index.js',
      hash = '87a75273aeb79846bab6f6361d28c0a0c12463f4',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 44,
          column: 5
        }
      },
      '1': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 32
        }
      },
      '2': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 68
        }
      },
      '3': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 49
        }
      },
      '4': {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 7
        }
      },
      '5': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 36
        }
      },
      '6': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 32
        }
      },
      '7': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 51
        }
      },
      '8': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 36
        }
      },
      '9': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 43,
          column: 7
        }
      },
      '10': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      '11': {
        start: {
          line: 35,
          column: 30
        },
        end: {
          line: 35,
          column: 58
        }
      },
      '12': {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 39,
          column: 11
        }
      },
      '13': {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 64
        }
      },
      '14': {
        start: {
          line: 40,
          column: 10
        },
        end: {
          line: 40,
          column: 21
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 14,
            column: 7
          },
          end: {
            line: 14,
            column: 8
          }
        },
        loc: {
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 16,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 17,
            column: 10
          },
          end: {
            line: 17,
            column: 11
          }
        },
        loc: {
          start: {
            line: 17,
            column: 83
          },
          end: {
            line: 44,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 32,
            column: 36
          },
          end: {
            line: 32,
            column: 37
          }
        },
        loc: {
          start: {
            line: 32,
            column: 49
          },
          end: {
            line: 43,
            column: 5
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 18
          }
        },
        loc: {
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 41,
            column: 9
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        }, {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1dn4f012xl.s[0];
angular.module('app', ['ui.router', 'ngLodash', 'toastr',
// 'ngAnimate',
'angular-loading-bar', 'ui.tree', 'ngCookies', 'ui.bootstrap', 'angularMoment', 'chart.js']).run(["amMoment", function (amMoment) {
  ++cov_1dn4f012xl.f[0];
  ++cov_1dn4f012xl.s[1];

  amMoment.changeLocale('fr');
}]).config(["cfpLoadingBarProvider", "toastrConfig", "ChartJsProvider", "$httpProvider", function (cfpLoadingBarProvider, toastrConfig, ChartJsProvider, $httpProvider) {
  ++cov_1dn4f012xl.f[1];
  ++cov_1dn4f012xl.s[2];

  // $httpProvider.defaults.withCredentials = true;

  cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
  ++cov_1dn4f012xl.s[3];
  cfpLoadingBarProvider.includeSpinner = false;
  // Charts.js
  ++cov_1dn4f012xl.s[4];
  ChartJsProvider.setOptions({
    colors: ['#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#803690']
  });

  ++cov_1dn4f012xl.s[5];
  toastrConfig.autoDismiss = true;
  ++cov_1dn4f012xl.s[6];
  toastrConfig.timeOut = 2000;
  ++cov_1dn4f012xl.s[7];
  toastrConfig.positionClass = 'toast-top-right';
  ++cov_1dn4f012xl.s[8];
  toastrConfig.progressBar = true;

  ++cov_1dn4f012xl.s[9];
  $httpProvider.interceptors.push(["$injector", function ($injector) {
    ++cov_1dn4f012xl.f[2];
    ++cov_1dn4f012xl.s[10];

    return {
      request: function request(req) {
        ++cov_1dn4f012xl.f[3];

        var authService = (++cov_1dn4f012xl.s[11], $injector.get('AuthService'));
        // On place le token d'identification dans chaque requête, pour autant qu'il y en ait un.
        ++cov_1dn4f012xl.s[12];
        if (authService.sessionId()) {
          ++cov_1dn4f012xl.b[0][0];
          ++cov_1dn4f012xl.s[13];

          req.headers.Authorization = authService.sessionId();
        } else {
          ++cov_1dn4f012xl.b[0][1];
        }
        ++cov_1dn4f012xl.s[14];
        return req;
      }
    };
  }]);
}]);
'use strict';

var cov_13iq2atie9 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/tree-view-structure/tree-view-structure.component.js',
      hash = 'a7a7025c3de45735824ac89d280eedf2bf5eadc1',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/tree-view-structure/tree-view-structure.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 27
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 84
        }
      },
      '4': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      '5': {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 26,
          column: 24
        }
      },
      '6': {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 24
        }
      },
      '7': {
        start: {
          line: 28,
          column: 23
        },
        end: {
          line: 28,
          column: 25
        }
      },
      '8': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 42
        }
      },
      '9': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 47,
          column: 7
        }
      },
      '10': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 37,
          column: 8
        }
      },
      '11': {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 46,
          column: 7
        }
      },
      '12': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      '13': {
        start: {
          line: 41,
          column: 10
        },
        end: {
          line: 41,
          column: 46
        }
      },
      '14': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 58
        }
      },
      '15': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 49
        }
      },
      '16': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '17': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 60,
          column: 7
        }
      },
      '18': {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 11
        }
      },
      '19': {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 44
        }
      },
      '20': {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 59,
          column: 11
        }
      },
      '21': {
        start: {
          line: 58,
          column: 10
        },
        end: {
          line: 58,
          column: 65
        }
      },
      '22': {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 21
        }
      },
      '23': {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 23
        }
      },
      '24': {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      '25': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      '26': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 78,
          column: 9
        }
      },
      '27': {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 77,
          column: 37
        }
      },
      '28': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 35
        }
      },
      '29': {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      '30': {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 83
        }
      },
      '31': {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 28
        }
      },
      '32': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 22
        }
      },
      '33': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 55
        }
      },
      '34': {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      '35': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 94
        }
      },
      '36': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 34
        }
      },
      '37': {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 28
        }
      },
      '38': {
        start: {
          line: 112,
          column: 30
        },
        end: {
          line: 112,
          column: 87
        }
      },
      '39': {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      '40': {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 58
        }
      },
      '41': {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 48
        }
      },
      '42': {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 28
        }
      },
      '43': {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 130,
          column: 7
        }
      },
      '44': {
        start: {
          line: 138,
          column: 23
        },
        end: {
          line: 138,
          column: 56
        }
      },
      '45': {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 72
        }
      },
      '46': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 39
        }
      },
      '47': {
        start: {
          line: 145,
          column: 23
        },
        end: {
          line: 145,
          column: 69
        }
      },
      '48': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 146,
          column: 72
        }
      },
      '49': {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 39
        }
      },
      '50': {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 152,
          column: 5
        }
      },
      '51': {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 83
        }
      },
      '52': {
        start: {
          line: 157,
          column: 0
        },
        end: {
          line: 166,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 45
          },
          end: {
            line: 6,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 12
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 64,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 32,
            column: 17
          },
          end: {
            line: 32,
            column: 18
          }
        },
        loc: {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 47,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 49,
            column: 22
          },
          end: {
            line: 49,
            column: 23
          }
        },
        loc: {
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 61,
            column: 5
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 53,
            column: 22
          }
        },
        loc: {
          start: {
            line: 53,
            column: 30
          },
          end: {
            line: 55,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 57,
            column: 21
          },
          end: {
            line: 57,
            column: 22
          }
        },
        loc: {
          start: {
            line: 57,
            column: 30
          },
          end: {
            line: 59,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 37
          },
          end: {
            line: 91,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 105,
            column: 3
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 41
          },
          end: {
            line: 121,
            column: 3
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 21
          },
          end: {
            line: 131,
            column: 3
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 26
          },
          end: {
            line: 141,
            column: 3
          }
        }
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 36
          },
          end: {
            line: 153,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 41
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 41
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 60,
            column: 7
          }
        }]
      },
      '4': {
        loc: {
          start: {
            line: 71,
            column: 24
          },
          end: {
            line: 71,
            column: 35
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 71,
            column: 31
          },
          end: {
            line: 71,
            column: 35
          }
        }]
      },
      '5': {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }]
      },
      '6': {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }]
      },
      '7': {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 26
          }
        }, {
          start: {
            line: 76,
            column: 30
          },
          end: {
            line: 76,
            column: 59
          }
        }]
      },
      '8': {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }]
      },
      '9': {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }]
      },
      '10': {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }]
      },
      '11': {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    b: {
      '0': [0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeViewStructureComponent = function () {
  TreeViewStructureComponent.$inject = ["$log", "$state", "$filter", "lodash"];
  function TreeViewStructureComponent($log, $state, $filter, lodash) {
    _classCallCheck(this, TreeViewStructureComponent);

    ++cov_13iq2atie9.f[0];
    ++cov_13iq2atie9.s[0];

    this.$log = $log;
    ++cov_13iq2atie9.s[1];
    this.$filter = $filter;
    ++cov_13iq2atie9.s[2];
    this.lodash = lodash;
  }

  _createClass(TreeViewStructureComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_13iq2atie9.f[1];
      ++cov_13iq2atie9.s[3];

      // types de structures.
      this.types = this.lodash.uniqBy(this.lodash.map(this.structures, 'type'), 'id');
      // treeview
      ++cov_13iq2atie9.s[4];
      this.treeview = {
        data: this.displayStructuresWithTreeView(this.structures),
        rawData: this.structures,
        selected: [],
        search: '',
        selectAll: false
      };
    }

    /**
     * affichage des structures en arbre.
     */

  }, {
    key: 'displayStructuresWithTreeView',
    value: function displayStructuresWithTreeView() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_13iq2atie9.b[0][0], []);
      ++cov_13iq2atie9.f[2];

      var nodesTree = (++cov_13iq2atie9.s[5], []);
      var heritages = (++cov_13iq2atie9.s[6], []);
      var nodesTable = (++cov_13iq2atie9.s[7], []);

      ++cov_13iq2atie9.s[8];
      data = this.lodash.uniqBy(data, 'id');

      ++cov_13iq2atie9.s[9];
      data.forEach(function (structure) {
        ++cov_13iq2atie9.f[3];
        ++cov_13iq2atie9.s[10];

        nodesTable[structure.id] = {
          name: structure.name,
          id: structure.id,
          children: []
        };

        ++cov_13iq2atie9.s[11];
        if (structure.parent) {
          ++cov_13iq2atie9.b[1][0];
          ++cov_13iq2atie9.s[12];

          if (!heritages[structure.parent.id]) {
            ++cov_13iq2atie9.b[2][0];
            ++cov_13iq2atie9.s[13];

            heritages[structure.parent.id] = [];
          } else {
            ++cov_13iq2atie9.b[2][1];
          }
          ++cov_13iq2atie9.s[14];
          heritages[structure.parent.id].push(structure.id);
        } else {
          ++cov_13iq2atie9.b[1][1];
          ++cov_13iq2atie9.s[15];

          nodesTree.push(nodesTable[structure.id]);
        }
      });
      // console.log(heritages);
      ++cov_13iq2atie9.s[16];
      heritages.forEach(function (node, nodeIndex) {
        ++cov_13iq2atie9.f[4];
        ++cov_13iq2atie9.s[17];

        // nodes[nodeIndex].children = node;
        if (!nodesTable[nodeIndex]) {
          ++cov_13iq2atie9.b[3][0];
          ++cov_13iq2atie9.s[18];

          // heritages[nodeIndex].forEach()
          node.forEach(function (child) {
            ++cov_13iq2atie9.f[5];
            ++cov_13iq2atie9.s[19];

            nodesTree.push(nodesTable[child]);
          });
        } else {
          ++cov_13iq2atie9.b[3][1];
          ++cov_13iq2atie9.s[20];

          node.forEach(function (child) {
            ++cov_13iq2atie9.f[6];
            ++cov_13iq2atie9.s[21];

            nodesTable[nodeIndex].children.push(nodesTable[child]);
          });
        }
      });

      ++cov_13iq2atie9.s[22];
      return nodesTree;
    }

    /**
     * Récupérer les structures en fonction du type sélectionné.
     * @type {[type]}
     */

  }, {
    key: 'getStructuresFromType',
    value: function getStructuresFromType() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_13iq2atie9.b[4][0], null);
      ++cov_13iq2atie9.f[7];

      var structures = (++cov_13iq2atie9.s[23], []);

      ++cov_13iq2atie9.s[24];
      if (type !== null) {
        ++cov_13iq2atie9.b[5][0];
        ++cov_13iq2atie9.s[25];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.structures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var structure = _step.value;
            ++cov_13iq2atie9.s[26];

            if ((++cov_13iq2atie9.b[7][0], structure.type) && (++cov_13iq2atie9.b[7][1], structure.type.id === type.id)) {
              ++cov_13iq2atie9.b[6][0];
              ++cov_13iq2atie9.s[27];

              structures.push(structure);
            } else {
              ++cov_13iq2atie9.b[6][1];
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        ++cov_13iq2atie9.b[5][1];
        ++cov_13iq2atie9.s[28];

        structures = this.structures;
      }

      ++cov_13iq2atie9.s[29];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[8][0];
        ++cov_13iq2atie9.s[30];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(structures, 'id'));
      } else {
        ++cov_13iq2atie9.b[8][1];
      }

      ++cov_13iq2atie9.s[31];
      this.emitSelectedData();

      ++cov_13iq2atie9.s[32];
      return structures;
    }

    // sélectionnez toutes les structures de l'arbre

  }, {
    key: 'selectAllDataFromTreeview',
    value: function selectAllDataFromTreeview() {
      ++cov_13iq2atie9.f[8];
      ++cov_13iq2atie9.s[33];

      // cocher la case.
      this.treeview.selectAll = !this.treeview.selectAll;

      ++cov_13iq2atie9.s[34];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[9][0];
        ++cov_13iq2atie9.s[35];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(this.treeview.rawData, 'id'));
      } else {
        ++cov_13iq2atie9.b[9][1];
        ++cov_13iq2atie9.s[36];

        this.treeview.selected = [];
      }

      ++cov_13iq2atie9.s[37];
      this.emitSelectedData();
    }

    /**
     * Sélectionnez une structure dans l'arbre
     */

  }, {
    key: 'selectStructureFromTreeView',
    value: function selectStructureFromTreeView(structure) {
      ++cov_13iq2atie9.f[9];

      var hasStructureIndex = (++cov_13iq2atie9.s[38], this.lodash.indexOf(this.treeview.selected, structure.id));

      ++cov_13iq2atie9.s[39];
      if (hasStructureIndex >= 0) {
        ++cov_13iq2atie9.b[10][0];
        ++cov_13iq2atie9.s[40];

        this.treeview.selected.splice(hasStructureIndex, 1);
      } else {
        ++cov_13iq2atie9.b[10][1];
        ++cov_13iq2atie9.s[41];

        this.treeview.selected.push(structure.id);
      }

      ++cov_13iq2atie9.s[42];
      this.emitSelectedData();
    }

    /**
     * Emit parent component.
     */

  }, {
    key: 'emitSelectedData',
    value: function emitSelectedData() {
      ++cov_13iq2atie9.f[10];
      ++cov_13iq2atie9.s[43];

      this.onChange({
        value: this.treeview.selected
      });
    }

    /**
     * LISTENERS.
     */

  }, {
    key: 'listenTypeChange',
    value: function listenTypeChange(value) {
      ++cov_13iq2atie9.f[11];

      var structures = (++cov_13iq2atie9.s[44], this.getStructuresFromType(value));
      ++cov_13iq2atie9.s[45];
      this.treeview.data = this.displayStructuresWithTreeView(structures);
      ++cov_13iq2atie9.s[46];
      this.treeview.rawData = structures;
    }
  }, {
    key: 'listenSearchTreeviewChange',
    value: function listenSearchTreeviewChange(value) {
      ++cov_13iq2atie9.f[12];

      // TODO Reset Types de structure.
      var structures = (++cov_13iq2atie9.s[47], this.$filter('filter')(this.structures, value));
      ++cov_13iq2atie9.s[48];
      this.treeview.data = this.displayStructuresWithTreeView(structures);
      // raw data
      ++cov_13iq2atie9.s[49];
      this.treeview.rawData = structures;

      ++cov_13iq2atie9.s[50];
      if (this.treeview.selectAll) {
        ++cov_13iq2atie9.b[11][0];
        ++cov_13iq2atie9.s[51];

        this.treeview.selected = this.lodash.uniq(this.lodash.map(structures, 'id'));
      } else {
        ++cov_13iq2atie9.b[11][1];
      }
    }
  }]);

  return TreeViewStructureComponent;
}();

++cov_13iq2atie9.s[52];


angular.module('app').component('treeViewStructure', {
  bindings: {
    structures: '<',
    onChange: '&'
  },
  templateUrl: 'app/dashboard/tree-view-structure/tree-view-structure.template.html',
  controller: TreeViewStructureComponent
});
'use strict';

var cov_jko19f4gi = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/datamart-indicator/datamart-indicator.component.js',
      hash = '1a70480600e7a079dbbaa3c2fa08e206b8a924a9',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/datamart-indicator/datamart-indicator.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 27
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 31
        }
      },
      '4': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 38,
          column: 11
        }
      },
      '5': {
        start: {
          line: 22,
          column: 10
        },
        end: {
          line: 22,
          column: 28
        }
      },
      '6': {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 33
        }
      },
      '7': {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 28,
          column: 40
        }
      },
      '8': {
        start: {
          line: 35,
          column: 10
        },
        end: {
          line: 37,
          column: 13
        }
      },
      '9': {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 134,
          column: 5
        }
      },
      '10': {
        start: {
          line: 63,
          column: 20
        },
        end: {
          line: 63,
          column: 24
        }
      },
      '11': {
        start: {
          line: 64,
          column: 35
        },
        end: {
          line: 64,
          column: 39
        }
      },
      '12': {
        start: {
          line: 65,
          column: 30
        },
        end: {
          line: 65,
          column: 34
        }
      },
      '13': {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 73,
          column: 8
        }
      },
      '14': {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 71
        }
      },
      '15': {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 61
        }
      },
      '16': {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 31
        }
      },
      '17': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 88,
          column: 8
        }
      },
      '18': {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 87
        }
      },
      '19': {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 71
        }
      },
      '20': {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 103
        }
      },
      '21': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      '22': {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 85,
          column: 13
        }
      },
      '23': {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 61
        }
      },
      '24': {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 96,
          column: 8
        }
      },
      '25': {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 95,
          column: 9
        }
      },
      '26': {
        start: {
          line: 92,
          column: 10
        },
        end: {
          line: 94,
          column: 13
        }
      },
      '27': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 103,
          column: 8
        }
      },
      '28': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 102,
          column: 11
        }
      },
      '29': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 115,
          column: 8
        }
      },
      '30': {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 114,
          column: 11
        }
      },
      '31': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 125,
          column: 8
        }
      },
      '32': {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 44
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 7,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 11,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 14
          },
          end: {
            line: 39,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 21,
            column: 15
          },
          end: {
            line: 21,
            column: 16
          }
        },
        loc: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 23,
            column: 9
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 24,
            column: 26
          },
          end: {
            line: 26,
            column: 9
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 28
          }
        },
        loc: {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 29,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 9
          }
        },
        loc: {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 38,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 17
          }
        },
        loc: {
          start: {
            line: 62,
            column: 34
          },
          end: {
            line: 133,
            column: 5
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 67,
            column: 22
          },
          end: {
            line: 67,
            column: 23
          }
        },
        loc: {
          start: {
            line: 67,
            column: 34
          },
          end: {
            line: 73,
            column: 7
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 75,
            column: 29
          },
          end: {
            line: 75,
            column: 30
          }
        },
        loc: {
          start: {
            line: 75,
            column: 41
          },
          end: {
            line: 88,
            column: 7
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 90,
            column: 19
          },
          end: {
            line: 90,
            column: 20
          }
        },
        loc: {
          start: {
            line: 90,
            column: 31
          },
          end: {
            line: 96,
            column: 7
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 99,
            column: 31
          },
          end: {
            line: 99,
            column: 32
          }
        },
        loc: {
          start: {
            line: 99,
            column: 48
          },
          end: {
            line: 103,
            column: 7
          }
        }
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 111,
            column: 28
          }
        },
        loc: {
          start: {
            line: 111,
            column: 39
          },
          end: {
            line: 115,
            column: 7
          }
        }
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 123,
            column: 30
          },
          end: {
            line: 123,
            column: 31
          }
        },
        loc: {
          start: {
            line: 123,
            column: 51
          },
          end: {
            line: 125,
            column: 7
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }, {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 95,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatamartIndicatorComponent = function () {
  DatamartIndicatorComponent.$inject = ["$log", "$uibModal", "$state", "$filter", "lodash"];
  function DatamartIndicatorComponent($log, $uibModal, $state, $filter, lodash) {
    _classCallCheck(this, DatamartIndicatorComponent);

    ++cov_jko19f4gi.f[0];
    ++cov_jko19f4gi.s[0];

    this.$log = $log;
    ++cov_jko19f4gi.s[1];
    this.$filter = $filter;
    ++cov_jko19f4gi.s[2];
    this.lodash = lodash;
    ++cov_jko19f4gi.s[3];
    this.$uibModal = $uibModal;
  }

  _createClass(DatamartIndicatorComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_jko19f4gi.f[1];
    }

    /**
     * Open modal.
     */

  }, {
    key: 'openModal',
    value: function openModal() {
      var _this = this;

      ++cov_jko19f4gi.f[2];
      ++cov_jko19f4gi.s[4];

      this.$uibModal.open({
        component: 'modalComponent',
        resolve: {
          marts: function marts() {
            ++cov_jko19f4gi.f[3];
            ++cov_jko19f4gi.s[5];

            return _this.marts;
          },
          indicators: function indicators() {
            ++cov_jko19f4gi.f[4];
            ++cov_jko19f4gi.s[6];

            return _this.indicators;
          },
          selectedIndicator: function selectedIndicator() {
            ++cov_jko19f4gi.f[5];
            ++cov_jko19f4gi.s[7];

            return _this.selectedIndicator;
          }
        }
      }).result.then(function (response) {
        ++cov_jko19f4gi.f[6];
        ++cov_jko19f4gi.s[8];

        _this.onChange({
          value: response
        });
      });
    }
  }]);

  return DatamartIndicatorComponent;
}();

++cov_jko19f4gi.s[9];


angular.module('app').component('datamartIndicator', {
  bindings: {
    marts: '<',
    indicators: '<',
    onChange: '&',
    selectedIndicator: '='
  },
  templateUrl: 'app/dashboard/datamart-indicator/datamart-indicator.template.html',
  controller: DatamartIndicatorComponent
}).component('modalComponent', {
  templateUrl: 'modal.html',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: ["lodash", function controller(lodash) {
    ++cov_jko19f4gi.f[7];

    var $ctrl = (++cov_jko19f4gi.s[10], this);
    var cloneSelectedIndicator = (++cov_jko19f4gi.s[11], null);
    var cloneSelectedMart = (++cov_jko19f4gi.s[12], null);

    ++cov_jko19f4gi.s[13];
    $ctrl.$onInit = function () {
      ++cov_jko19f4gi.f[8];
      ++cov_jko19f4gi.s[14];

      // indicators & marts
      $ctrl.indicators = lodash.get($ctrl.resolve, 'indicators', []);
      ++cov_jko19f4gi.s[15];
      $ctrl.marts = lodash.get($ctrl.resolve, 'marts', []);
      // Previous Select.
      ++cov_jko19f4gi.s[16];
      $ctrl.previousSelect();
    };

    ++cov_jko19f4gi.s[17];
    $ctrl.previousSelect = function () {
      ++cov_jko19f4gi.f[9];
      ++cov_jko19f4gi.s[18];

      // selected indicator
      $ctrl.selectedIndicator = lodash.get($ctrl.resolve, 'selectedIndicator', null);
      ++cov_jko19f4gi.s[19];
      cloneSelectedIndicator = angular.copy($ctrl.selectedIndicator);
      // selected mart
      ++cov_jko19f4gi.s[20];
      $ctrl.selectedMart = lodash.get($ctrl.selectedIndicator, 'datamart', lodash.head($ctrl.marts));
      // is String.
      ++cov_jko19f4gi.s[21];
      if (lodash.isString($ctrl.selectedMart)) {
        ++cov_jko19f4gi.b[0][0];
        ++cov_jko19f4gi.s[22];

        $ctrl.selectedMart = lodash.find($ctrl.marts, {
          id: $ctrl.selectedMart
        });
      } else {
        ++cov_jko19f4gi.b[0][1];
      }
      ++cov_jko19f4gi.s[23];
      cloneSelectedMart = angular.copy($ctrl.selectedMart);
    };

    ++cov_jko19f4gi.s[24];
    $ctrl.save = function () {
      ++cov_jko19f4gi.f[10];
      ++cov_jko19f4gi.s[25];

      if ($ctrl.selectedIndicator) {
        ++cov_jko19f4gi.b[1][0];
        ++cov_jko19f4gi.s[26];

        $ctrl.close({
          $value: $ctrl.selectedIndicator
        });
      } else {
        ++cov_jko19f4gi.b[1][1];
      }
    };

    // Listen Mart change.
    ++cov_jko19f4gi.s[27];
    $ctrl.listenMartChange = function (value) {
      ++cov_jko19f4gi.f[11];
      ++cov_jko19f4gi.s[28];

      $ctrl.indicators = lodash.filter($ctrl.resolve.indicators, {
        datamart: value.id
      });
    };

    /**
     * CLose and save
     * @method closeAndSave
     * @return {}
     */

    ++cov_jko19f4gi.s[29];
    $ctrl.closeAndSave = function () {
      ++cov_jko19f4gi.f[12];
      ++cov_jko19f4gi.s[30];

      $ctrl.close({
        $value: cloneSelectedIndicator
      });
    };

    /**
     * Sélectionnez un indicateur.
     * @method selectIndicator
     * @return {}
     */

    ++cov_jko19f4gi.s[31];
    $ctrl.selectIndicator = function (indicator) {
      ++cov_jko19f4gi.f[13];
      ++cov_jko19f4gi.s[32];

      $ctrl.selectedIndicator = indicator;
    };

    //
    // $ctrl.cancel = function () {
    //   $ctrl.dismiss({
    //     $value: 'cancel'
    //   });
    // };
  }]
});
'use strict';

var cov_1dj86pxxuw = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/chart/chart.component.js',
      hash = '98c8b995dfce54a82aa0da11323d1898275a8cbb',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/chart/chart.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 25,
          column: 6
        }
      },
      '2': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 65
        }
      },
      '3': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 21
        }
      },
      '4': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 21
        }
      },
      '5': {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 24
        }
      },
      '6': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 30
        }
      },
      '7': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 30
        }
      },
      '8': {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 33
        }
      },
      '9': {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 42,
          column: 31
        }
      },
      '10': {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 25
        }
      },
      '11': {
        start: {
          line: 44,
          column: 23
        },
        end: {
          line: 44,
          column: 31
        }
      },
      '12': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      '13': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 42
        }
      },
      '14': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      '15': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 37
        }
      },
      '16': {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 37
        }
      },
      '17': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 28
        }
      },
      '18': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '19': {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 41
        }
      },
      '20': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 41
        }
      },
      '21': {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 48
        }
      },
      '22': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 48
        }
      },
      '23': {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 71
        }
      },
      '24': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 82,
          column: 7
        }
      },
      '25': {
        start: {
          line: 70,
          column: 25
        },
        end: {
          line: 70,
          column: 27
        }
      },
      '26': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 32
        }
      },
      '27': {
        start: {
          line: 72,
          column: 20
        },
        end: {
          line: 72,
          column: 56
        }
      },
      '28': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      '29': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 52
        }
      },
      '30': {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 50
        }
      },
      '31': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 34
        }
      },
      '32': {
        start: {
          line: 87,
          column: 0
        },
        end: {
          line: 109,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 36,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 83,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 58,
            column: 30
          },
          end: {
            line: 58,
            column: 31
          }
        },
        loc: {
          start: {
            line: 58,
            column: 39
          },
          end: {
            line: 61,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 69,
            column: 36
          },
          end: {
            line: 69,
            column: 37
          }
        },
        loc: {
          start: {
            line: 69,
            column: 43
          },
          end: {
            line: 82,
            column: 5
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartComponent = function () {
  ChartComponent.$inject = ["lodash"];
  function ChartComponent(lodash) {
    _classCallCheck(this, ChartComponent);

    ++cov_1dj86pxxuw.f[0];
    ++cov_1dj86pxxuw.s[0];

    this.lodash = lodash;
  }

  _createClass(ChartComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_1dj86pxxuw.f[1];
      ++cov_1dj86pxxuw.s[1];

      // Graphique Options.
      this.options = {
        scaleStartValue: 0,
        legend: {
          display: true,
          position: "top",
          labels: {
            fontSize: 14
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              beginAtZero: true
            }
          }]
        }
      };
      // Type du graphique
      ++cov_1dj86pxxuw.s[2];
      this.type = this.lodash.get(this.indicator, 'chart', 'line');
      // series
      ++cov_1dj86pxxuw.s[3];
      this.series = [];
      // labels
      ++cov_1dj86pxxuw.s[4];
      this.labels = [];
      // chartData
      ++cov_1dj86pxxuw.s[5];
      this.chartData = [];
      // log
      ++cov_1dj86pxxuw.s[6];
      this.parseData(this.data);
    }
  }, {
    key: 'parseData',
    value: function parseData(data) {
      var _this = this;

      ++cov_1dj86pxxuw.f[2];
      ++cov_1dj86pxxuw.s[7];

      // Copy data pour manipulation.
      data = angular.copy(data);
      var labelName = (++cov_1dj86pxxuw.s[8], 'date_valeur');
      var serieName = (++cov_1dj86pxxuw.s[9], 'structure');
      var refName = (++cov_1dj86pxxuw.s[10], 'serie');
      var valeurName = (++cov_1dj86pxxuw.s[11], 'valeur');

      // Si c'est horizontal bar
      ++cov_1dj86pxxuw.s[12];
      if (this.type === 'horizontal-bar') {
        ++cov_1dj86pxxuw.b[0][0];
        ++cov_1dj86pxxuw.s[13];

        this.options.legend.display = false;
      } else {
        ++cov_1dj86pxxuw.b[0][1];
      }

      ++cov_1dj86pxxuw.s[14];
      if (this.type !== 'line') {
        ++cov_1dj86pxxuw.b[1][0];
        ++cov_1dj86pxxuw.s[15];

        labelName = 'dimension_valeur';
        ++cov_1dj86pxxuw.s[16];
        serieName = 'dimension_valeur';
        ++cov_1dj86pxxuw.s[17];
        refName = 'reference';
      } else {
        ++cov_1dj86pxxuw.b[1][1];
      }

      // Data foreach.
      ++cov_1dj86pxxuw.s[18];
      this.lodash.forEach(data, function (value) {
        ++cov_1dj86pxxuw.f[3];
        ++cov_1dj86pxxuw.s[19];

        _this.labels.push(value[labelName]);
        ++cov_1dj86pxxuw.s[20];
        _this.series.push(value[serieName]);
      });

      // uniq.
      ++cov_1dj86pxxuw.s[21];
      this.labels = this.lodash.uniq(this.labels);
      ++cov_1dj86pxxuw.s[22];
      this.series = this.lodash.uniq(this.series);

      // lier les données avec les series.
      var references = (++cov_1dj86pxxuw.s[23], this.lodash.uniq(this.lodash.map(data, refName)));
      ++cov_1dj86pxxuw.s[24];
      this.lodash.forEach(references, function (ref) {
        ++cov_1dj86pxxuw.f[4];

        var comparator = (++cov_1dj86pxxuw.s[25], {});
        ++cov_1dj86pxxuw.s[26];
        comparator[refName] = ref;
        var facts = (++cov_1dj86pxxuw.s[27], _this.lodash.filter(data, comparator));
        // extraction de la valeur.
        var values = void 0;
        ++cov_1dj86pxxuw.s[28];
        if (_this.type !== 'line') {
          ++cov_1dj86pxxuw.b[2][0];
          ++cov_1dj86pxxuw.s[29];

          values = _this.lodash.sumBy(facts, 'valeur');
        } else {
          ++cov_1dj86pxxuw.b[2][1];
          ++cov_1dj86pxxuw.s[30];

          values = _this.lodash.map(facts, 'valeur');
        }

        ++cov_1dj86pxxuw.s[31];
        _this.chartData.push(values);
      });
    }
  }]);

  return ChartComponent;
}();

++cov_1dj86pxxuw.s[32];


angular.module('app').component('chart', {
  bindings: {
    indicator: '=',
    data: '='
  },
  template: '\n    <div ng-if="$ctrl.type === \'line\'">\n    <canvas id="line" class="chart chart-line" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'pie\'">\n    <canvas id="pie" class="chart chart-pie" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'bar\'">\n    <canvas id="bar" class="chart chart-bar" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'horizontal-bar\'">\n    <canvas class="chart-horizontal-bar" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    ',
  controller: ChartComponent
});
'use strict';

var cov_2pj1xkepi4 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/m2o/m2o.component.js',
      hash = '8dff4106bc64caccf2a59a56a2e215414b3acef4',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/m2o/m2o.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 21
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 25
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '3': {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 57
        }
      },
      '4': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 16,
          column: 5
        }
      },
      '5': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 13
        }
      },
      '6': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 25
        }
      },
      '7': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      '8': {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 48,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 28
          },
          end: {
            line: 5,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 11,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        loc: {
          start: {
            line: 13,
            column: 22
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 38
          },
          end: {
            line: 33,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 8,
            column: 8
          },
          end: {
            line: 8,
            column: 29
          }
        }, {
          start: {
            line: 8,
            column: 33
          },
          end: {
            line: 8,
            column: 50
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 5
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 36
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 36
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var M2oComponent = function () {
  M2oComponent.$inject = ["$log", "lodash"];
  function M2oComponent($log, lodash) {
    _classCallCheck(this, M2oComponent);

    ++cov_2pj1xkepi4.f[0];
    ++cov_2pj1xkepi4.s[0];

    this.$log = $log;
    ++cov_2pj1xkepi4.s[1];
    this.lodash = lodash;
  }

  _createClass(M2oComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_2pj1xkepi4.f[1];
      ++cov_2pj1xkepi4.s[2];

      if ((++cov_2pj1xkepi4.b[1][0], !this.selectedElement) && (++cov_2pj1xkepi4.b[1][1], !this.firstOption)) {
        ++cov_2pj1xkepi4.b[0][0];
        ++cov_2pj1xkepi4.s[3];

        this.selectedElement = this.lodash.head(this.data);
      } else {
        ++cov_2pj1xkepi4.b[0][1];
      }
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      ++cov_2pj1xkepi4.f[2];
      ++cov_2pj1xkepi4.s[4];

      if (this.lodash(changes, 'selectedElement.currentValue', null)) {
        ++cov_2pj1xkepi4.b[2][0];
        ++cov_2pj1xkepi4.s[5];

        return;
      } else {
        ++cov_2pj1xkepi4.b[2][1];
      }

      ++cov_2pj1xkepi4.s[6];
      console.log(changes);
    }

    // compile() {
    //   console.log(this);
    //   // on prends la précaution de supprimer les éventuels doublons.
    //   // this.elements = this.lodash.uniqBy(this.data, 'id');
    //   this.elements = this.data;
    // }

  }, {
    key: 'listenChangeElement',
    value: function listenChangeElement() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_2pj1xkepi4.b[3][0], null);
      ++cov_2pj1xkepi4.f[3];
      ++cov_2pj1xkepi4.s[7];

      // emit on change.
      this.onChange({
        value: element
      });
    }
  }]);

  return M2oComponent;
}();

++cov_2pj1xkepi4.s[8];


angular.module('app').component('m2o', {
  bindings: {
    data: '=',
    firstOption: '@',
    selectedElement: '<',
    onChange: '&'
  },
  templateUrl: 'app/components/m2o/m2o.template.html',
  controller: M2oComponent
});
'use strict';

var cov_1286eelyjw = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/datepicker/datepicker.component.js',
      hash = 'ce141a4ec25a6b019957802bd1915a3834d29519',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/components/datepicker/datepicker.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 31
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 24
        }
      },
      '3': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 12,
          column: 6
        }
      },
      '4': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 18,
          column: 5
        }
      },
      '5': {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 28
        }
      },
      '6': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      '7': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 52
        }
      },
      '8': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 24
        }
      },
      '9': {
        start: {
          line: 34,
          column: 17
        },
        end: {
          line: 34,
          column: 56
        }
      },
      '10': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '11': {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 52,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 13,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 19,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 27,
            column: 3
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 26
          },
          end: {
            line: 38,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }, {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 18,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatepickerComponent = function () {
  DatepickerComponent.$inject = ["moment"];
  function DatepickerComponent(moment) {
    _classCallCheck(this, DatepickerComponent);

    ++cov_1286eelyjw.f[0];
    ++cov_1286eelyjw.s[0];

    this.moment = moment;
  }

  _createClass(DatepickerComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_1286eelyjw.f[1];
      ++cov_1286eelyjw.s[1];

      this.format = "dd/MM/yyyy";
      ++cov_1286eelyjw.s[2];
      this.isOpen = false;
      ++cov_1286eelyjw.s[3];
      this.options = {
        startingDay: 1,
        showWeeks: false
      };
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      ++cov_1286eelyjw.f[2];
      ++cov_1286eelyjw.s[4];

      if (changes.value.currentValue) {
        ++cov_1286eelyjw.b[0][0];
        ++cov_1286eelyjw.s[5];

        this.parseInputDate();
      } else {
        ++cov_1286eelyjw.b[0][1];
      }
    }
  }, {
    key: 'parseInputDate',
    value: function parseInputDate() {
      ++cov_1286eelyjw.f[3];
      ++cov_1286eelyjw.s[6];

      if (this.value) {
        ++cov_1286eelyjw.b[1][0];
        ++cov_1286eelyjw.s[7];

        this.value = this.moment(this.value).toDate();
      } else {
        ++cov_1286eelyjw.b[1][1];
        ++cov_1286eelyjw.s[8];

        this.value = null;
      }
    }

    /**
     * Ecoute changemrnt de date.
     */

  }, {
    key: 'listenDateChange',
    value: function listenDateChange(value) {
      ++cov_1286eelyjw.f[4];

      var date = (++cov_1286eelyjw.s[9], this.moment(value).format('YYYY-MM-DD'));
      ++cov_1286eelyjw.s[10];
      this.onChange({
        value: date
      });
    }
  }]);

  return DatepickerComponent;
}();

++cov_1286eelyjw.s[11];


angular.module('app').component('datepicker', {
  bindings: {
    value: '<',
    options: '<',
    placeholder: '@',
    onChange: '&'
  },
  templateUrl: 'app/components/datepicker/datepicker.template.html',
  controller: DatepickerComponent
});
'use strict';

var cov_17kwlq8qme = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/main/main.js',
      hash = '5f4a0ab639f1a306c7f13708e0eb5ce019784423',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/main/main.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 21
        }
      },
      '2': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 35
        }
      },
      '3': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 32
        }
      },
      '4': {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 23,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 28
          },
          end: {
            line: 5,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 16
          },
          end: {
            line: 15,
            column: 3
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppComponent = function () {
  AppComponent.$inject = ["$log", "$state"];
  function AppComponent($log, $state) {
    _classCallCheck(this, AppComponent);

    ++cov_17kwlq8qme.f[0];
    ++cov_17kwlq8qme.s[0];

    this.$state = $state;
    ++cov_17kwlq8qme.s[1];
    this.$log = $log;
  }

  /**
   * La connexion a réussie.
   */

  _createClass(AppComponent, [{
    key: 'authSuccess',
    value: function authSuccess() {
      ++cov_17kwlq8qme.f[1];
      ++cov_17kwlq8qme.s[2];

      this.$log.info('Auth Success');

      ++cov_17kwlq8qme.s[3];
      this.$state.go('dashboard');
    }
  }]);

  return AppComponent;
}();

++cov_17kwlq8qme.s[4];


angular.module('app').component('main', {
  templateUrl: 'app/main/main.html',
  controller: AppComponent
});
'use strict';

var cov_2hqcdwjh8y = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/header/header.js',
      hash = '43239afb5c8607a6d234a3401ced3edab37f0dab',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/header/header.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 8,
          column: 5
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_2hqcdwjh8y.s[0];
angular.module('app').component('martyHeader', {
  bindings: {
    user: '='
  },
  templateUrl: 'app/header/header.html'
});
'use strict';

var cov_gft10of9 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/dashboard.component.js',
      hash = '52432ab72f587dd02cc189db252d0695a18644d5',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/dashboard.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 21
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 25
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 27
        }
      },
      '4': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 27
        }
      },
      '5': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 25
        }
      },
      '6': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 25
        }
      },
      '7': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 37
        }
      },
      '8': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 35
        }
      },
      '9': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 40
        }
      },
      '10': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      '11': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      '12': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      '13': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 64,
          column: 6
        }
      },
      '14': {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 33
        }
      },
      '15': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 32
        }
      },
      '16': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      '17': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 13
        }
      },
      '18': {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      '19': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 13
        }
      },
      '20': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 31
        }
      },
      '21': {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 120,
          column: 11
        }
      },
      '22': {
        start: {
          line: 99,
          column: 10
        },
        end: {
          line: 116,
          column: 13
        }
      },
      '23': {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 87
        }
      },
      '24': {
        start: {
          line: 102,
          column: 12
        },
        end: {
          line: 113,
          column: 13
        }
      },
      '25': {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 88
        }
      },
      '26': {
        start: {
          line: 105,
          column: 16
        },
        end: {
          line: 105,
          column: 22
        }
      },
      '27': {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 87
        }
      },
      '28': {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 22
        }
      },
      '29': {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 87
        }
      },
      '30': {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 111,
          column: 22
        }
      },
      '31': {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 78
        }
      },
      '32': {
        start: {
          line: 118,
          column: 10
        },
        end: {
          line: 118,
          column: 41
        }
      },
      '33': {
        start: {
          line: 119,
          column: 10
        },
        end: {
          line: 119,
          column: 38
        }
      },
      '34': {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      '35': {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 24
        }
      },
      '36': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 14
        }
      },
      '37': {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 25
        }
      },
      '38': {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 14
        }
      },
      '39': {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 24
        }
      },
      '40': {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 139,
          column: 14
        }
      },
      '41': {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 24
        }
      },
      '42': {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 14
        }
      },
      '43': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      '44': {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 101
        }
      },
      '45': {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 97
        }
      },
      '46': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 91
        }
      },
      '47': {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 87
        }
      },
      '48': {
        start: {
          line: 150,
          column: 11
        },
        end: {
          line: 155,
          column: 5
        }
      },
      '49': {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 106
        }
      },
      '50': {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 102
        }
      },
      '51': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 96
        }
      },
      '52': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 92
        }
      },
      '53': {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 19
        }
      },
      '54': {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 43
        }
      },
      '55': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 19
        }
      },
      '56': {
        start: {
          line: 170,
          column: 27
        },
        end: {
          line: 173,
          column: 5
        }
      },
      '57': {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 175,
          column: 91
        }
      },
      '58': {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 185,
          column: 5
        }
      },
      '59': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 184,
          column: 13
        }
      },
      '60': {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 68
        }
      },
      '61': {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 19
        }
      },
      '62': {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 194,
          column: 5
        }
      },
      '63': {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 193,
          column: 13
        }
      },
      '64': {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 66
        }
      },
      '65': {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 19
        }
      },
      '66': {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 202,
          column: 68
        }
      },
      '67': {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 74
        }
      },
      '68': {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 206,
          column: 43
        }
      },
      '69': {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 208,
          column: 64
        }
      },
      '70': {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 19
        }
      },
      '71': {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 35
        }
      },
      '72': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 19
        }
      },
      '73': {
        start: {
          line: 224,
          column: 0
        },
        end: {
          line: 233,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 97
          },
          end: {
            line: 12,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 70,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 121,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        },
        loc: {
          start: {
            line: 97,
            column: 18
          },
          end: {
            line: 120,
            column: 9
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 99,
            column: 38
          },
          end: {
            line: 99,
            column: 39
          }
        },
        loc: {
          start: {
            line: 99,
            column: 47
          },
          end: {
            line: 116,
            column: 11
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 32
          },
          end: {
            line: 158,
            column: 3
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 160,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        loc: {
          start: {
            line: 160,
            column: 27
          },
          end: {
            line: 163,
            column: 3
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 169,
            column: 3
          }
        },
        loc: {
          start: {
            line: 169,
            column: 27
          },
          end: {
            line: 176,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 31
          },
          end: {
            line: 189,
            column: 3
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 3
          }
        },
        loc: {
          start: {
            line: 191,
            column: 29
          },
          end: {
            line: 198,
            column: 3
          }
        }
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 3
          }
        },
        loc: {
          start: {
            line: 200,
            column: 31
          },
          end: {
            line: 211,
            column: 3
          }
        }
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 217,
            column: 2
          },
          end: {
            line: 217,
            column: 3
          }
        },
        loc: {
          start: {
            line: 217,
            column: 30
          },
          end: {
            line: 220,
            column: 3
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 82,
            column: 152
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 82,
            column: 9
          },
          end: {
            line: 82,
            column: 31
          }
        }, {
          start: {
            line: 82,
            column: 35
          },
          end: {
            line: 82,
            column: 55
          }
        }, {
          start: {
            line: 82,
            column: 61
          },
          end: {
            line: 82,
            column: 104
          }
        }, {
          start: {
            line: 82,
            column: 108
          },
          end: {
            line: 82,
            column: 151
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 77
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 30
          }
        }, {
          start: {
            line: 86,
            column: 34
          },
          end: {
            line: 86,
            column: 77
          }
        }]
      },
      '4': {
        loc: {
          start: {
            line: 102,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 103,
            column: 14
          },
          end: {
            line: 105,
            column: 22
          }
        }, {
          start: {
            line: 106,
            column: 14
          },
          end: {
            line: 108,
            column: 22
          }
        }, {
          start: {
            line: 109,
            column: 14
          },
          end: {
            line: 111,
            column: 22
          }
        }, {
          start: {
            line: 112,
            column: 14
          },
          end: {
            line: 112,
            column: 22
          }
        }]
      },
      '5': {
        loc: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 127,
            column: 30
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 127,
            column: 24
          },
          end: {
            line: 127,
            column: 30
          }
        }]
      },
      '6': {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 143,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 133,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 136,
            column: 14
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 139,
            column: 14
          }
        }, {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 14
          }
        }]
      },
      '7': {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }]
      },
      '8': {
        loc: {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 150,
            column: 11
          },
          end: {
            line: 155,
            column: 5
          }
        }]
      },
      '9': {
        loc: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }]
      },
      '10': {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0, 0, 0],
      '5': [0],
      '6': [0, 0, 0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardComponent = function () {
  DashboardComponent.$inject = ["$log", "$state", "$window", "toastr", "MartyService", "AuthService", "moment", "$filter", "lodash"];
  function DashboardComponent($log, $state, $window, toastr, MartyService, AuthService, moment, $filter, lodash) {
    _classCallCheck(this, DashboardComponent);

    ++cov_gft10of9.f[0];
    ++cov_gft10of9.s[0];

    this.$state = $state;
    ++cov_gft10of9.s[1];
    this.$log = $log;
    ++cov_gft10of9.s[2];
    this.toastr = toastr;
    ++cov_gft10of9.s[3];
    this.$window = $window;
    ++cov_gft10of9.s[4];
    this.$filter = $filter;
    ++cov_gft10of9.s[5];
    this.lodash = lodash;
    ++cov_gft10of9.s[6];
    this.moment = moment;
    ++cov_gft10of9.s[7];
    this.martyService = MartyService;
    ++cov_gft10of9.s[8];
    this.authService = AuthService;
  }

  _createClass(DashboardComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_gft10of9.f[1];
      ++cov_gft10of9.s[9];

      // user
      this.user = this.authService.user();
      // filters.
      ++cov_gft10of9.s[10];
      this.filters = {
        structures: this.authService.user('structures'),
        // type de periode.
        periodType: null,
        // activePeriodType
        activePeriodType: null,
        // selected indicator
        selectedIndicator: null,
        // sélection unique
        indicators: this.indicators,
        // sélection unique
        marts: this.marts,
        // start date
        startDate: this.moment().startOf('year'),
        // end date
        endDate: this.moment().endOf('year')
      };

      /**
       * Paramètre de recherche.
       * @type {Object}
       */

      ++cov_gft10of9.s[11];
      this.params = {
        // indicateur
        indicator: null,
        // structures
        structures: null,
        // date de début
        startDate: this.filters.startDate.format('YYYY-MM-DD'),
        // date de fin
        endDate: this.filters.endDate.format('YYYY-MM-DD')
      };

      // sort params.
      ++cov_gft10of9.s[12];
      this.sortParams = {
        type: 'date_valeur',
        reverse: false,
        search: ''
      };

      // available periodtype
      ++cov_gft10of9.s[13];
      this.availablePeriodType = {
        W: ["W", "M", "Y"],
        M: ["M", "Y"],
        Y: ["Y"]
      };

      // Valeur récupèrées du DATAWH
      ++cov_gft10of9.s[14];
      this.valuesFromDatawh = null;
      // is Fetching Data.
      ++cov_gft10of9.s[15];
      this.isFetchingData = false;
    }

    /**
     * Recupérer les structures en fonction du type
     */

    /**
     * Get values.
     */

  }, {
    key: 'getData',
    value: function getData() {
      var _this = this;

      ++cov_gft10of9.f[2];
      ++cov_gft10of9.s[16];

      // check dates.
      if ((++cov_gft10of9.b[1][0], !this.params.startDate) || (++cov_gft10of9.b[1][1], !this.params.endDate) || (++cov_gft10of9.b[1][2], this.params.startDate > this.params.endDate) || (++cov_gft10of9.b[1][3], this.params.endDate < this.params.startDate)) {
        ++cov_gft10of9.b[0][0];
        ++cov_gft10of9.s[17];

        return;
      } else {
        ++cov_gft10of9.b[0][1];
      }
      // check another indicator
      ++cov_gft10of9.s[18];
      if ((++cov_gft10of9.b[3][0], !this.params.indicator) || (++cov_gft10of9.b[3][1], this.lodash.isEmpty(this.params.structures))) {
        ++cov_gft10of9.b[2][0];
        ++cov_gft10of9.s[19];

        return;
      } else {
        ++cov_gft10of9.b[2][1];
      }

      // fetch data loader.
      ++cov_gft10of9.s[20];
      this.isFetchingData = true;

      ++cov_gft10of9.s[21];
      this.martyService.getValues(this.params).then(function (values) {
        ++cov_gft10of9.f[3];
        ++cov_gft10of9.s[22];

        // parsed
        _this.lodash.forEach(values, function (value) {
          ++cov_gft10of9.f[4];
          ++cov_gft10of9.s[23];

          value.date_valeur_fr = _this.moment(value.date_valeur).format('DD/MM/YYYY');
          // parsed date
          ++cov_gft10of9.s[24];
          switch (_this.filters.periodType) {
            case 'W':
              ++cov_gft10of9.b[4][0];
              ++cov_gft10of9.s[25];

              value.date_valeur = _this.moment(value.date_valeur).format('DD/MM/YYYY');
              ++cov_gft10of9.s[26];
              break;
            case 'M':
              ++cov_gft10of9.b[4][1];
              ++cov_gft10of9.s[27];

              value.date_valeur = _this.moment(value.date_valeur).format('MMMM YYYY');
              ++cov_gft10of9.s[28];
              break;
            case 'Y':
              ++cov_gft10of9.b[4][2];
              ++cov_gft10of9.s[29];

              value.date_valeur = _this.moment(value.date_valeur).format('MMMM YYYY');
              ++cov_gft10of9.s[30];
              break;
            default:
              ++cov_gft10of9.b[4][3];

          }
          // parsed value
          ++cov_gft10of9.s[31];
          value.formattedValue = _this.$filter('currency')(value.valeur, "");
        });

        ++cov_gft10of9.s[32];
        _this.valuesFromDatawh = values;
        ++cov_gft10of9.s[33];
        _this.isFetchingData = false;
      });
    }

    /**
     * Changer la période.
     */

  }, {
    key: 'changePeriod',
    value: function changePeriod() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_gft10of9.b[5][0], 'next');
      ++cov_gft10of9.f[5];

      var period = void 0;

      ++cov_gft10of9.s[34];
      switch (this.filters.activePeriodType) {
        case 'W':
          ++cov_gft10of9.b[6][0];
          ++cov_gft10of9.s[35];

          period = 'week';
          ++cov_gft10of9.s[36];
          break;
        case 'M':
          ++cov_gft10of9.b[6][1];
          ++cov_gft10of9.s[37];

          period = 'month';
          ++cov_gft10of9.s[38];
          break;
        case 'Y':
          ++cov_gft10of9.b[6][2];
          ++cov_gft10of9.s[39];

          period = 'year';
          ++cov_gft10of9.s[40];
          break;
        default:
          ++cov_gft10of9.b[6][3];
          ++cov_gft10of9.s[41];

          period = 'week';
          ++cov_gft10of9.s[42];
          break;
      }

      ++cov_gft10of9.s[43];
      if (action === 'next') {
        ++cov_gft10of9.b[7][0];
        ++cov_gft10of9.s[44];

        this.params.startDate = this.moment(this.params.startDate).add(1, period).format('YYYY-MM-DD');
        ++cov_gft10of9.s[45];
        this.params.endDate = this.moment(this.params.endDate).add(1, period).format('YYYY-MM-DD');
        ++cov_gft10of9.s[46];
        this.filters.startDate = this.moment(this.filters.startDate).add(1, period).toDate();
        ++cov_gft10of9.s[47];
        this.filters.endDate = this.moment(this.filters.endDate).add(1, period).toDate();
      } else {
          ++cov_gft10of9.b[7][1];
          ++cov_gft10of9.s[48];
          if (action === 'prev') {
            ++cov_gft10of9.b[8][0];
            ++cov_gft10of9.s[49];

            this.params.startDate = this.moment(this.params.startDate).subtract(1, period).format('YYYY-MM-DD');
            ++cov_gft10of9.s[50];
            this.params.endDate = this.moment(this.params.endDate).subtract(1, period).format('YYYY-MM-DD');
            ++cov_gft10of9.s[51];
            this.filters.startDate = this.moment(this.filters.startDate).subtract(1, period).toDate();
            ++cov_gft10of9.s[52];
            this.filters.endDate = this.moment(this.filters.endDate).subtract(1, period).toDate();
          } else {
            ++cov_gft10of9.b[8][1];
          }
        } // reload graph.
      ++cov_gft10of9.s[53];
      this.getData();
    }
  }, {
    key: 'changePeriodType',
    value: function changePeriodType(period) {
      ++cov_gft10of9.f[6];
      ++cov_gft10of9.s[54];

      this.filters.activePeriodType = period;
      ++cov_gft10of9.s[55];
      this.getData();
    }

    /**
     * Exporter
     */

  }, {
    key: 'exportValuesFromDatawh',
    value: function exportValuesFromDatawh() {
      ++cov_gft10of9.f[7];

      var periodInterval = (++cov_gft10of9.s[56], {
        startDate: this.moment(this.params.startDate).format('DD/MM/YYYY'),
        endDate: this.moment(this.params.endDate).format('DD/MM/YYYY')
      });
      ++cov_gft10of9.s[57];
      this.martyService.exportValues(this.valuesFromDatawh, this.filters.selectedIndicator, periodInterval);
    }

    /**
     * listen
     */

  }, {
    key: 'listenStartDateChange',
    value: function listenStartDateChange(value) {
      ++cov_gft10of9.f[8];
      ++cov_gft10of9.s[58];

      if (value > this.params.endDate) {
        ++cov_gft10of9.b[9][0];
        ++cov_gft10of9.s[59];

        return;
      } else {
        ++cov_gft10of9.b[9][1];
      }

      ++cov_gft10of9.s[60];
      this.params.startDate = this.moment(value).format('YYYY-MM-DD');
      ++cov_gft10of9.s[61];
      this.getData();
    }
  }, {
    key: 'listenEndDateChange',
    value: function listenEndDateChange(value) {
      ++cov_gft10of9.f[9];
      ++cov_gft10of9.s[62];

      if (value < this.params.startDate) {
        ++cov_gft10of9.b[10][0];
        ++cov_gft10of9.s[63];

        return;
      } else {
        ++cov_gft10of9.b[10][1];
      }

      ++cov_gft10of9.s[64];
      this.params.endDate = this.moment(value).format('YYYY-MM-DD');
      ++cov_gft10of9.s[65];
      this.getData();
    }
  }, {
    key: 'listenIndicatorChange',
    value: function listenIndicatorChange(value) {
      ++cov_gft10of9.f[10];
      ++cov_gft10of9.s[66];

      // period type
      this.filters.periodType = this.lodash.get(value, 'period_type');
      // active period type
      ++cov_gft10of9.s[67];
      this.filters.activePeriodType = this.lodash.get(value, 'period_type');
      // selected indicator
      ++cov_gft10of9.s[68];
      this.filters.selectedIndicator = value;
      // params indicator.
      ++cov_gft10of9.s[69];
      this.params.indicator = this.lodash.get(value, 'indicator');
      // get data
      ++cov_gft10of9.s[70];
      this.getData();
    }

    /**
     * Assignation des structures.
     */

  }, {
    key: 'listenTreeViewChange',
    value: function listenTreeViewChange(value) {
      ++cov_gft10of9.f[11];
      ++cov_gft10of9.s[71];

      this.params.structures = value;
      ++cov_gft10of9.s[72];
      this.getData();
    }
  }]);

  return DashboardComponent;
}();

++cov_gft10of9.s[73];


angular.module('app').component('dashboard', {
  bindings: {
    indicators: '<',
    marts: '<'
  },
  templateUrl: 'app/dashboard/dashboard.template.html',
  controller: DashboardComponent
});
'use strict';

var cov_n9vluxf2i = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/auth/auth.component.js',
      hash = '1f699a5934651ada41fc4f6825449ce7e4c2542b',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/auth/auth.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 27
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 29
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 35
        }
      },
      '3': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 19
        }
      },
      '4': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 25
        }
      },
      '5': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 29
        }
      },
      '6': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 20
        }
      },
      '7': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      '8': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 6
        }
      },
      '9': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '10': {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 67
        }
      },
      '11': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '12': {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 24
        }
      },
      '13': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 33
        }
      },
      '14': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 57,
          column: 11
        }
      },
      '15': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 67
        }
      },
      '16': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 27
        }
      },
      '17': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 55,
          column: 37
        }
      },
      '18': {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 40
        }
      },
      '19': {
        start: {
          line: 62,
          column: 0
        },
        end: {
          line: 124,
          column: 5
        }
      },
      '20': {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 123,
          column: 6
        }
      },
      '21': {
        start: {
          line: 79,
          column: 21
        },
        end: {
          line: 79,
          column: 66
        }
      },
      '22': {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      '23': {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 22
        }
      },
      '24': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 42
        }
      },
      '25': {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 48
        }
      },
      '26': {
        start: {
          line: 101,
          column: 22
        },
        end: {
          line: 101,
          column: 32
        }
      },
      '27': {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 107,
          column: 10
        }
      },
      '28': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 119,
          column: 13
        }
      },
      '29': {
        start: {
          line: 112,
          column: 12
        },
        end: {
          line: 112,
          column: 81
        }
      },
      '30': {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 113,
          column: 84
        }
      },
      '31': {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 43
        }
      },
      '32': {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 118,
          column: 45
        }
      },
      '33': {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 29
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 69
          },
          end: {
            line: 9,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 24,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 28
          },
          end: {
            line: 38,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 31,
            column: 19
          }
        },
        loc: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 37,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 58,
            column: 3
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        loc: {
          start: {
            line: 50,
            column: 14
          },
          end: {
            line: 54,
            column: 9
          }
        }
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 54,
            column: 11
          },
          end: {
            line: 54,
            column: 12
          }
        },
        loc: {
          start: {
            line: 54,
            column: 20
          },
          end: {
            line: 57,
            column: 9
          }
        }
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 71,
            column: 63
          },
          end: {
            line: 124,
            column: 3
          }
        }
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 110,
            column: 11
          }
        },
        loc: {
          start: {
            line: 110,
            column: 29
          },
          end: {
            line: 116,
            column: 11
          }
        }
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 117,
            column: 10
          },
          end: {
            line: 117,
            column: 11
          }
        },
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 119,
            column: 11
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 30,
            column: 11
          },
          end: {
            line: 30,
            column: 26
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 26
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 7
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 78,
            column: 11
          },
          end: {
            line: 78,
            column: 26
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 78,
            column: 22
          },
          end: {
            line: 78,
            column: 26
          }
        }]
      },
      '3': {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    b: {
      '0': [0],
      '1': [0, 0],
      '2': [0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthComponent = function () {
  AuthComponent.$inject = ["$window", "$cookies", "$timeout", "AuthService", "lodash", "API"];
  function AuthComponent($window, $cookies, $timeout, AuthService, lodash, API) {
    _classCallCheck(this, AuthComponent);

    ++cov_n9vluxf2i.f[0];
    ++cov_n9vluxf2i.s[0];

    this.$window = $window;
    ++cov_n9vluxf2i.s[1];
    this.$timeout = $timeout;
    ++cov_n9vluxf2i.s[2];
    this.authService = AuthService;
    ++cov_n9vluxf2i.s[3];
    this.api = API;
    ++cov_n9vluxf2i.s[4];
    this.lodash = lodash;
    ++cov_n9vluxf2i.s[5];
    this.$cookies = $cookies;
  }

  _createClass(AuthComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_n9vluxf2i.f[1];
      ++cov_n9vluxf2i.s[6];

      this.setFocus();

      ++cov_n9vluxf2i.s[7];
      this.credentials = {
        username: null,
        instance: this.$cookies.get('instance'),
        password: null
      };

      ++cov_n9vluxf2i.s[8];
      this.request = {
        fetching: false,
        error: null
      };
    }

    /**
     * Cette méthode permet d'assigner le focus.
     */

  }, {
    key: 'setFocus',
    value: function setFocus() {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_n9vluxf2i.b[0][0], 'username');
      ++cov_n9vluxf2i.f[2];
      ++cov_n9vluxf2i.s[9];

      this.$timeout(function () {
        ++cov_n9vluxf2i.f[3];

        var element = (++cov_n9vluxf2i.s[10], _this.$window.document.querySelector('#' + id));

        ++cov_n9vluxf2i.s[11];
        if (element) {
          ++cov_n9vluxf2i.b[1][0];
          ++cov_n9vluxf2i.s[12];

          element.focus();
        } else {
          ++cov_n9vluxf2i.b[1][1];
        }
      });
    }

    /**
     * Envoi du formulaire
     */

  }, {
    key: 'doSubmit',
    value: function doSubmit() {
      var _this2 = this;

      ++cov_n9vluxf2i.f[4];
      ++cov_n9vluxf2i.s[13];

      this.request.fetching = true;

      ++cov_n9vluxf2i.s[14];
      this.authService.auth(this.credentials).then(function () {
        ++cov_n9vluxf2i.f[5];
        ++cov_n9vluxf2i.s[15];

        // Store instance.
        _this2.$cookies.put('instance', _this2.credentials.instance);
        ++cov_n9vluxf2i.s[16];
        _this2.onSuccess();
      }, function (error) {
        ++cov_n9vluxf2i.f[6];
        ++cov_n9vluxf2i.s[17];

        _this2.request.error = error;
        ++cov_n9vluxf2i.s[18];
        _this2.request.fetching = false;
      });
    }
  }]);

  return AuthComponent;
}();

++cov_n9vluxf2i.s[19];


angular.module('app').component('auth', {
  bindings: {
    onSuccess: '&'
  },
  controller: AuthComponent,
  templateUrl: 'app/auth/auth.component.html'
}).factory('AuthService', ["$http", "$window", "$q", "lodash", "API", function ($http, $window, $q, lodash, API) {
  ++cov_n9vluxf2i.f[7];
  ++cov_n9vluxf2i.s[20];

  return {

    /**
     * Retourne l'utilisateur courant.
     */

    user: function user() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_n9vluxf2i.b[2][0], null);

      var user = (++cov_n9vluxf2i.s[21], angular.fromJson($window.sessionStorage.user));

      ++cov_n9vluxf2i.s[22];
      if (property === null) {
        ++cov_n9vluxf2i.b[3][0];
        ++cov_n9vluxf2i.s[23];

        return user;
      } else {
        ++cov_n9vluxf2i.b[3][1];
      }

      ++cov_n9vluxf2i.s[24];
      return lodash.get(user, property);
    },


    /**
     * Retourne le sessionId.
     */

    sessionId: function sessionId() {
      ++cov_n9vluxf2i.s[25];

      return $window.sessionStorage.sessionId;
    },


    /**
     * Méthode d'authentification
     */

    auth: function auth(credentials) {
      var defer = (++cov_n9vluxf2i.s[26], $q.defer());

      var request = (++cov_n9vluxf2i.s[27], $http({
        url: API + '/auth',
        method: 'POST',
        data: credentials
      }));

      ++cov_n9vluxf2i.s[28];
      request.then(function (responseSuccess) {
        ++cov_n9vluxf2i.f[8];
        ++cov_n9vluxf2i.s[29];

        // Store User.
        $window.sessionStorage.sessionId = responseSuccess.data.access_token;
        ++cov_n9vluxf2i.s[30];
        $window.sessionStorage.user = angular.toJson(responseSuccess.data.user);

        ++cov_n9vluxf2i.s[31];
        defer.resolve(responseSuccess);
      }, function (responseError) {
        ++cov_n9vluxf2i.f[9];
        ++cov_n9vluxf2i.s[32];

        defer.reject(responseError.data);
      });

      ++cov_n9vluxf2i.s[33];
      return defer.promise;
    }
  };
}]);
'use strict';

var cov_2nk5x3yeg7 = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/marty.service.js',
      hash = '50b1236254a6c9cf62d8b1d0c8c6f8e53c589c11',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/marty.service.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 90,
          column: 5
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 89,
          column: 6
        }
      },
      '2': {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 32
        }
      },
      '3': {
        start: {
          line: 12,
          column: 24
        },
        end: {
          line: 15,
          column: 10
        }
      },
      '4': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 20,
          column: 13
        }
      },
      '5': {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 48
        }
      },
      '6': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 29
        }
      },
      '7': {
        start: {
          line: 30,
          column: 22
        },
        end: {
          line: 30,
          column: 32
        }
      },
      '8': {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 34,
          column: 10
        }
      },
      '9': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 39,
          column: 13
        }
      },
      '10': {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 48
        }
      },
      '11': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 29
        }
      },
      '12': {
        start: {
          line: 49,
          column: 22
        },
        end: {
          line: 49,
          column: 32
        }
      },
      '13': {
        start: {
          line: 51,
          column: 24
        },
        end: {
          line: 55,
          column: 10
        }
      },
      '14': {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 66,
          column: 13
        }
      },
      '15': {
        start: {
          line: 59,
          column: 27
        },
        end: {
          line: 59,
          column: 47
        }
      },
      '16': {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 63,
          column: 15
        }
      },
      '17': {
        start: {
          line: 62,
          column: 14
        },
        end: {
          line: 62,
          column: 59
        }
      },
      '18': {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 34
        }
      },
      '19': {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 29
        }
      },
      '20': {
        start: {
          line: 72,
          column: 24
        },
        end: {
          line: 80,
          column: 10
        }
      },
      '21': {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 87,
          column: 13
        }
      },
      '22': {
        start: {
          line: 84,
          column: 29
        },
        end: {
          line: 84,
          column: 49
        }
      },
      '23': {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 86,
          column: 89
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 27
          },
          end: {
            line: 3,
            column: 28
          }
        },
        loc: {
          start: {
            line: 3,
            column: 72
          },
          end: {
            line: 90,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 35
          },
          end: {
            line: 20,
            column: 11
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 17
          }
        },
        loc: {
          start: {
            line: 37,
            column: 35
          },
          end: {
            line: 39,
            column: 11
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 58,
            column: 16
          },
          end: {
            line: 58,
            column: 17
          }
        },
        loc: {
          start: {
            line: 58,
            column: 35
          },
          end: {
            line: 66,
            column: 11
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 61,
            column: 31
          },
          end: {
            line: 61,
            column: 32
          }
        },
        loc: {
          start: {
            line: 61,
            column: 36
          },
          end: {
            line: 63,
            column: 13
          }
        }
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 83,
            column: 16
          },
          end: {
            line: 83,
            column: 17
          }
        },
        loc: {
          start: {
            line: 83,
            column: 35
          },
          end: {
            line: 87,
            column: 11
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 48,
            column: 16
          },
          end: {
            line: 48,
            column: 29
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 48,
            column: 25
          },
          end: {
            line: 48,
            column: 29
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    b: {
      '0': [0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_2nk5x3yeg7.s[0];
angular.module('app').factory('MartyService', ["$http", "$window", "$q", "lodash", "moment", "API", function ($http, $window, $q, lodash, moment, API) {
  ++cov_2nk5x3yeg7.f[0];
  ++cov_2nk5x3yeg7.s[1];

  return {

    /**
     * Récupérer indicateurs.
     */

    getIndicators: function getIndicators() {
      var defer = (++cov_2nk5x3yeg7.s[2], $q.defer());
      var request = (++cov_2nk5x3yeg7.s[3], $http({
        url: API + '/datawh/indicators',
        method: 'GET'
      }));

      ++cov_2nk5x3yeg7.s[4];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[1];
        ++cov_2nk5x3yeg7.s[5];

        defer.resolve(responseSuccess.data);
      });

      ++cov_2nk5x3yeg7.s[6];
      return defer.promise;
    },


    /**
     * Récupérer les marts.
     */

    getMarts: function getMarts() {
      var defer = (++cov_2nk5x3yeg7.s[7], $q.defer());
      var request = (++cov_2nk5x3yeg7.s[8], $http({
        url: API + '/datawh/marts',
        method: 'GET'
      }));

      ++cov_2nk5x3yeg7.s[9];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[2];
        ++cov_2nk5x3yeg7.s[10];

        defer.resolve(responseSuccess.data);
      });

      ++cov_2nk5x3yeg7.s[11];
      return defer.promise;
    },


    /**
     * Récupérer les valeurs
     */

    getValues: function getValues() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (++cov_2nk5x3yeg7.b[0][0], null);

      var defer = (++cov_2nk5x3yeg7.s[12], $q.defer());

      var request = (++cov_2nk5x3yeg7.s[13], $http({
        url: API + '/datawh/values',
        method: 'POST',
        data: params
      }));

      ++cov_2nk5x3yeg7.s[14];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[3];

        var values = (++cov_2nk5x3yeg7.s[15], responseSuccess.data);

        ++cov_2nk5x3yeg7.s[16];
        lodash.map(values, function (o) {
          ++cov_2nk5x3yeg7.f[4];
          ++cov_2nk5x3yeg7.s[17];

          o.date_valeur_moment = moment(o.date_valeur);
        });

        ++cov_2nk5x3yeg7.s[18];
        defer.resolve(values);
      });

      ++cov_2nk5x3yeg7.s[19];
      return defer.promise;
    },
    exportValues: function exportValues(values, indicator, periodInterval) {
      var request = (++cov_2nk5x3yeg7.s[20], $http({
        url: API + '/datawh/export',
        method: 'POST',
        data: {
          values: values,
          indicator: indicator,
          periodInterval: periodInterval
        }
      }));

      ++cov_2nk5x3yeg7.s[21];
      request.then(function (responseSuccess) {
        ++cov_2nk5x3yeg7.f[5];

        var filename = (++cov_2nk5x3yeg7.s[22], responseSuccess.data);
        // download file
        ++cov_2nk5x3yeg7.s[23];
        $window.open(API + '/datawh/download-export?filename=' + filename, '_blank');
      });
    }
  };
}]);
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.component.html","<div class=\"auth-background\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-xs-12 col-md-4 col-md-offset-4\">\n        <form class=\"login-form\" name=\"authForm\" ng-submit=\"$ctrl.doSubmit()\">\n          <!-- Form group -->\n          <div class=\"form-group\">\n            <!-- <label for=\"username\">Nom d\'utilisateur</label> -->\n            <input type=\"text\" id=\"username\" name=\"username\" ng-model=\"$ctrl.credentials.username\" placeholder=\"Nom d\'utilisateur\" required>\n          </div>\n          <!-- Form group -->\n          <div class=\"form-group\">\n            <!-- <label for=\"instance\">Instance</label> -->\n            <input type=\"text\" id=\"instance\" name=\"instance\" ng-model=\"$ctrl.credentials.instance\" placeholder=\"Instance\" required>\n          </div>\n          <!-- Form group -->\n          <div class=\"form-group\">\n            <!-- <label for=\"password\">Mot de passe</label> -->\n            <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"$ctrl.credentials.password\" placeholder=\"Mot de passe\" required>\n          </div>\n          <div ng-if=\"$ctrl.request.error\">\n            <p class=\"text-danger text-center\">{{$ctrl.request.error}}</p>\n          </div>\n          <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block\" ng-disabled=\"authForm.$invalid || $ctrl.request.fetching\">\n            <span ng-if=\"!$ctrl.request.fetching\">Connexion</span>\n            <span ng-if=\"$ctrl.request.fetching\">Connexion en cours...</span>\n          </button>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/dashboard/dashboard.template.html","<marty-header user=\"$ctrl.user\">\n</marty-header>\n\n<!--  MASTER  DETAIL-->\n<div ng-class=\"{\'large-detail-view\' : $ctrl.largeDetailView}\">\n  <div class=\"master-view\">\n    <tree-view-structure structures=\"$ctrl.filters.structures\" on-change=\"$ctrl.listenTreeViewChange(value)\"></tree-view-structure>\n  </div>\n\n  <div class=\"nav-menu\">\n    <div class=\"container-fluid\">\n      <!-- PERIODE. -->\n      <div class=\"row\">\n        <!-- Date de début -->\n        <div class=\"col-xs-12 col-sm-6 datepicker\">\n          <!-- <div class=\"menu-bar pull-left\" ng-click=\"$ctrl.largeDetailView = !$ctrl.largeDetailView\">\n            <i class=\"fa fa-bars fa-2x\"></i>\n          </div> -->\n          <div class=\"menu-bar pull-left\" ng-class=\"{\'open\' : !$ctrl.largeDetailView}\" ng-click=\"$ctrl.largeDetailView = !$ctrl.largeDetailView\">\n            <span></span>\n            <span></span>\n            <span></span>\n            <span></span>\n            <span></span>\n            <span></span>\n          </div>\n          <datepicker placeholder=\"Date de début\" value=\"$ctrl.filters.startDate\" on-change=\"$ctrl.listenStartDateChange(value)\"></datepicker>\n        </div>\n        <!-- Date de fin -->\n        <div class=\"col-xs-12 col-sm-6 datepicker\">\n          <datepicker placeholder=\"Date de fin\" value=\"$ctrl.filters.endDate\" on-change=\"$ctrl.listenEndDateChange(value)\"></datepicker>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"detail-view\">\n    <div class=\"container-fluid\" style=\"margin-bottom:15px\">\n      <!-- DATAMART -->\n      <datamart-indicator marts=\"$ctrl.filters.marts\" indicators=\"$ctrl.filters.indicators\" on-change=\"$ctrl.listenIndicatorChange(value)\" selected-indicator=\"$ctrl.filters.selectedIndicator\">\n      </datamart-indicator>\n    </div>\n\n    <div class=\"container-fluid\" ng-if=\"$ctrl.valuesFromDatawh\">\n      <!-- Chart -->\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading panel-heading-col\">\n          <!-- Toolbar chart -->\n          <div class=\"col-xs-6 text-left\">\n            <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Rafraîchir\" ng-click=\"$ctrl.getData()\">\n              <i class=\"fa fa-refresh\"></i>\n            </a>\n            <span ng-if=\"$ctrl.valuesFromDatawh.length > 0\">\n              <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Afficher les données sous forme de tableau\" ng-show=\"!$ctrl.chart.toolbar.displayAsTable\" ng-click=\"$ctrl.chart.toolbar.displayAsTable = !$ctrl.chart.toolbar.displayAsTable\">\n                <i class=\"fa fa-list\"></i>\n              </a>\n              <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Afficher les données sous forme de graphique\" ng-show=\"$ctrl.chart.toolbar.displayAsTable\" ng-click=\"$ctrl.chart.toolbar.displayAsTable = !$ctrl.chart.toolbar.displayAsTable\">\n                <i class=\"fa fa-line-chart\"></i>\n              </a>\n              <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Exporter\" ng-show=\"$ctrl.chart.toolbar.displayAsTable\" ng-click=\"$ctrl.exportValuesFromDatawh()\">\n                <i class=\"fa fa-file-text-o\"></i>\n              </a>\n            </span>\n            <!-- Indicateur name -->\n            <span>\n              <i class=\"fa fa fa-refresh fa-spin\" style=\"margin-left:10px\" ng-if=\"$ctrl.isFetchingData\"></i>\n            </span>\n          </div>\n          <div class=\"col-xs-6 text-right\">\n            <div class=\"btn-group\">\n              <button class=\"btn btn-default\" ng-click=\"$ctrl.changePeriodType(\'W\');\" ng-class=\"{\'btn-primary\' : $ctrl.filters.activePeriodType == \'W\'}\" ng-disabled=\"$ctrl.availablePeriodType[$ctrl.filters.periodType].indexOf(\'W\') == -1\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Affichage par semaine\">\n                W\n                </button>\n                <button class=\"btn btn-default\" ng-click=\"$ctrl.changePeriodType(\'M\');\" ng-class=\"{\'btn-primary\' : $ctrl.filters.activePeriodType == \'M\'}\" ng-disabled=\"$ctrl.availablePeriodType[$ctrl.filters.periodType].indexOf(\'M\') == -1\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Affichage par mois\">\n                  M\n                  </button>\n\n                  <button class=\"btn btn-default\" ng-click=\"$ctrl.changePeriodType(\'Y\');\" ng-class=\"{\'btn-primary\' : $ctrl.filters.activePeriodType == \'Y\'}\" ng-disabled=\"$ctrl.availablePeriodType[$ctrl.filters.periodType].indexOf(\'Y\') == -1\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Affichage par an\">\n                    Y\n                    </button>\n            </div>\n            <div class=\"btn-group\">\n              <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Période précédente\" ng-click=\"$ctrl.changePeriod(\'prev\')\">\n                <i class=\"fa fa-arrow-left\"></i>\n              </a>\n              <a class=\"btn btn-default\" tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip=\"Période suivante\" ng-click=\"$ctrl.changePeriod(\'next\')\">\n                <i class=\"fa fa-arrow-right\"></i>\n              </a>\n            </div>\n          </div>\n        </div>\n        <div class=\"panel-body\">\n          <!-- No data -->\n          <div ng-if=\"$ctrl.valuesFromDatawh.length == 0\">\n            <p>Aucun résultat</p>\n          </div>\n          <!-- Chart component -->\n          <div class=\"chart-container\" ng-if=\"$ctrl.valuesFromDatawh.length > 0\">\n            <chart ng-if=\"!$ctrl.chart.toolbar.displayAsTable && !$ctrl.isFetchingData\" data=\"$ctrl.valuesFromDatawh\" indicator=\"$ctrl.filters.selectedIndicator\"></chart>\n          </div>\n          <!-- Data With table -->\n          <!-- tableau de données. -->\n          <div ng-if=\"$ctrl.chart.toolbar.displayAsTable\" ng-if=\"$ctrl.valuesFromDatawh.length > 0\">\n            <div class=\"input-group form-group\">\n              <span class=\"input-group-addon\">\n                <i class=\"fa fa-search\"></i>\n              </span>\n              <input type=\"text\" class=\"form-control\" placeholder=\"Rechercher...\" ng-model=\"$ctrl.sortParams.search\">\n            </div>\n            <table class=\"table table-striped table-hover text-left\">\n              <thead>\n                <tr>\n                  <th ng-click=\"$ctrl.sortParams.type = \'structure\'; $ctrl.sortParams.reverse = !$ctrl.sortParams.reverse\">\n                    Structure\n                    <span ng-show=\"$ctrl.sortParams.type == \'structure\' && !$ctrl.sortParams.reverse\" class=\"fa fa-caret-down text-primary\"></span>\n                    <span ng-show=\"$ctrl.sortParams.type == \'structure\' && $ctrl.sortParams.reverse\" class=\"fa fa-caret-up text-primary\"></span>\n                  </th>\n                  <th ng-click=\"$ctrl.sortParams.type = \'type\'; $ctrl.sortParams.reverse = !$ctrl.sortParams.reverse\">\n                    Type de structure\n                    <span ng-show=\"$ctrl.sortParams.type == \'type\' && !$ctrl.sortParams.reverse\" class=\"fa fa-caret-down text-primary\"></span>\n                    <span ng-show=\"$ctrl.sortParams.type == \'type\' && $ctrl.sortParams.reverse\" class=\"fa fa-caret-up text-primary\"></span>\n                  </th>\n                  <th ng-click=\"$ctrl.sortParams.type = \'date_valeur\'; $ctrl.sortParams.reverse = !$ctrl.sortParams.reverse\">\n                    Date\n                    <span ng-show=\"$ctrl.sortParams.type == \'date_valeur\' && !$ctrl.sortParams.reverse\" class=\"fa fa-caret-down text-primary\"></span>\n                    <span ng-show=\"$ctrl.sortParams.type == \'date_valeur\' && $ctrl.sortParams.reverse\" class=\"fa fa-caret-up text-primary\"></span>\n                  </th>\n                  <th ng-click=\"$ctrl.sortParams.type = \'dimension_valeur\'; $ctrl.sortParams.reverse = !$ctrl.sortParams.reverse\">\n                    Dimension\n                    <span ng-show=\"$ctrl.sortParams.type == \'dimension_valeur\' && !$ctrl.sortParams.reverse\" class=\"fa fa-caret-down text-primary\"></span>\n                    <span ng-show=\"$ctrl.sortParams.type == \'dimension_valeur\' && $ctrl.sortParams.reverse\" class=\"fa fa-caret-up text-primary\"></span>\n                  </th>\n                  <th ng-click=\"$ctrl.sortParams.type = \'formattedValue\'; $ctrl.sortParams.reverse = !$ctrl.sortParams.reverse\">\n                    Valeur\n                    <span ng-show=\"$ctrl.sortParams.type == \'formattedValue\' && !$ctrl.sortParams.reverse\" class=\"fa fa-caret-down text-primary\"></span>\n                    <span ng-show=\"$ctrl.sortParams.type == \'formattedValue\' && $ctrl.sortParams.reverse\" class=\"fa fa-caret-up text-primary\"></span>\n                  </th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"value in $ctrl.valuesFromDatawh | orderBy:$ctrl.sortParams.type:$ctrl.sortParams.reverse | filter:$ctrl.sortParams.search\">\n                  <td>{{value.structure}}</td>\n                  <td>{{value.type}}</td>\n                  <td>{{value.date_valeur}}</td>\n                  <td>{{value.dimension_valeur}}</td>\n                  <td>\n                    <b>{{value.formattedValue}}</b>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!--  VIEW DETAIL EMPTY-->\n  <div class=\"empty-detail-view\" ng-if=\"!$ctrl.params.structures || !$ctrl.valuesFromDatawh\">\n    <div class=\"msg-empty\">\n      <i class=\"fa fa-line-chart fa-5x\" ng-if=\"!$ctrl.isFetchingData\"></i>\n      <i class=\"fa fa-spinner fa-spin fa-5x\" ng-if=\"$ctrl.isFetchingData\"></i>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/header/header.html","<header class=\"header\">\n  <p class=\"header-profil\">\n    <img src=\"assets/images/profil.png\" class=\"img-responsive\" alt=\"\" ng-if=\"$ctrl.user\">{{$ctrl.user.name}}\n    <span class=\"btn-bar\" ui-sref=\"main\" style=\"padding:15px 10px 16px 5px;cursor:pointer\">\n      <i class=\"fa fa-power-off\"></i>\n    </span>\n\n  </p>\n  <p class=\"header-title\">MARTY</p>\n  <p class=\"header-date hidden-xs\">\n    Réalisé avec\n    <i style=\"font-size:1.2em;padding:0 5px;color:#F44336\" class=\"fa fa-heart\"></i> par\n    <a href=\"http://www.socianova.com/site/qui-sommes-nous/#equipe\" target=\"_blank\">\n      l\'équipe SociaNOVA\n    </a>\n  </p>\n</header>\n");
$templateCache.put("app/main/main.html","<auth on-success=\"$ctrl.authSuccess()\"></auth>\n");
$templateCache.put("app/components/datepicker/datepicker.template.html","<p class=\"input-group\">\n  <input type=\"text\" class=\"form-control\" show-button-bar=\"false\" popup-placement=\"bottom\" uib-datepicker-popup=\"{{$ctrl.format}}\" ng-model=\"$ctrl.value\" ng-change=\"$ctrl.listenDateChange($ctrl.value)\" is-open=\"$ctrl.isOpen\" datepicker-options=\"$ctrl.options\" placeholder=\"{{$ctrl.placeholder}}\">\n  <span class=\"input-group-btn\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.isOpen = true\">\n      <i class=\"glyphicon glyphicon-calendar\"></i>\n    </button>\n  </span>\n</p>\n");
$templateCache.put("app/components/m2o/m2o.template.html","<!-- Select -->\n<select ng-model=\"$ctrl.selectedElement\" ng-change=\"$ctrl.listenChangeElement($ctrl.selectedElement)\" ng-options=\"o as o.name for o in $ctrl.data\" class=\"form-control\">\n  <option value=\"\" ng-show=\"$ctrl.firstOption\" ng-selected=\"true\">{{$ctrl.firstOption}}</option>\n</select>\n");
$templateCache.put("app/dashboard/datamart-indicator/datamart-indicator.template.html","<div>\n  <button class=\"btn btn-primary btn-md btn-block\" ng-click=\"$ctrl.openModal()\" tooltip-placement=\"bottom\" uib-tooltip=\"Cliquez ici pour changer l\'indicateur\">\n    <span ng-if=\"$ctrl.selectedIndicator\">{{$ctrl.selectedIndicator.name}}</span>\n    <span ng-if=\"!$ctrl.selectedIndicator\">Choissisez un indicateur</span>\n  </button>\n</div>\n\n<!-- template -->\n<script type=\"text/ng-template\" id=\"modal.html\">\n  <!-- <div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Lorem ipsum</h3>\n  </div> -->\n  <div class=\"modal-body\" id=\"modal-body\">\n    <p>\n      <label class=\"text-primary\">Sélectionnez un datamart</label>\n      <m2o data=\"$ctrl.marts\" selected-element=\"$ctrl.selectedMart\" on-change=\"$ctrl.listenMartChange(value)\"></m2o>\n    </p>\n\n    <p>\n      <label class=\"text-primary\">Sélectionnez un indicateur</label>\n      <ul class=\"indicators\">\n        <!-- champ de recherche -->\n        <div class=\"input-group form-group\">\n          <span class=\"input-group-addon\">\n            <i class=\"fa fa-search\"></i>\n          </span>\n          <input type=\"text\" class=\"form-control\" placeholder=\"Rechercher...\" ng-model=\"$ctrl.search\">\n        </div>\n        <!-- sélection à gauche -->\n        <li ng-repeat=\"indicator in $ctrl.indicators | filter:{\'name\' : $ctrl.search}\" ng-class=\"{\'active\' : $ctrl.selectedIndicator.indicator == indicator.indicator, \'inactive\' : $ctrl.selectedIndicator.indicator != indicator.indicator}\" ng-click=\"$ctrl.selectIndicator(indicator)\">\n          {{indicator.name}}\n        </li>\n      </ul>\n    </p>\n\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.closeAndSave()\">Annuler</button>\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.save()\">Sélectionner</button>\n  </div>\n</script>\n");
$templateCache.put("app/dashboard/tree-view-structure/tree-view-structure.template.html","<div class=\"label-title\">Types de structures</div>\n<!-- TYPES DE STRUCTURES -->\n<m2o data=\"$ctrl.types\" first-option=\"Tous les types\" on-change=\"$ctrl.listenTypeChange(value)\"></m2o>\n<div class=\"label-title\">Structures</div>\n<!-- Structure search -->\n<div class=\"input-group form-group\">\n  <input type=\"text\" class=\"form-control\" placeholder=\"Rechercher...\" ng-model=\"$ctrl.treeview.search\" ng-change=\"$ctrl.listenSearchTreeviewChange($ctrl.treeview.search)\">\n  <span class=\"input-group-addon text-right\" ng-click=\"$ctrl.selectAllDataFromTreeview()\">\n    <i class=\"fa\" ng-class=\"{\'active fa-check-circle\' : $ctrl.treeview.selectAll, \'fa-circle-o\' : ! $ctrl.treeview.selectAll}\"></i>\n  </span>\n</div>\n<!-- STRUCTURES -->\n<div ui-tree data-nodrop-enabled=\"true\" data-drag-enabled=\"true\" ng-if=\"$ctrl.treeview.data.length > 0\">\n  <ol ui-tree-nodes ng-model=\"$ctrl.treeview.data\" id=\"tree-root\">\n    <li data-nodrag=\"true\" ng-repeat=\"node in $ctrl.treeview.data\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"></li>\n  </ol>\n</div>\n\n<!-- Nested node template -->\n<script type=\"text/ng-template\" id=\"nodes_renderer.html\">\n  <div ui-tree-handle ng-click=\"$ctrl.selectStructureFromTreeView(node)\" ng-class=\"{\'active\' : $ctrl.treeview.selected.indexOf(node.id) !== -1, \'inactive\' : $ctrl.treeview.selected.indexOf(node.id) === -1}\">\n    <i class=\"fa fa-home\"></i> {{node.name}}\n  </div>\n  <ol ui-tree-nodes=\"\" data-nodrag=\"true\" ng-model=\"node.children\">\n    <li ng-repeat=\"node in node.children\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\">\n    </li>\n  </ol>\n</script>\n");}]);
'use strict';

var cov_1zeczi1tpx = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/routes.js',
      hash = '42359fb8f3050c93d61f68539b38da982796cf20',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 24
        }
      },
      '1': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 52
        }
      },
      '2': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 36
        }
      },
      '3': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 14,
          column: 7
        }
      },
      '4': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 28,
          column: 7
        }
      },
      '5': {
        start: {
          line: 22,
          column: 10
        },
        end: {
          line: 22,
          column: 46
        }
      },
      '6': {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 41
        }
      }
    },
    fnMap: {
      '0': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 21
          }
        },
        loc: {
          start: {
            line: 6,
            column: 77
          },
          end: {
            line: 29,
            column: 1
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 21,
            column: 20
          },
          end: {
            line: 21,
            column: 21
          }
        },
        loc: {
          start: {
            line: 21,
            column: 36
          },
          end: {
            line: 23,
            column: 9
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 24,
            column: 15
          },
          end: {
            line: 24,
            column: 16
          }
        },
        loc: {
          start: {
            line: 24,
            column: 45
          },
          end: {
            line: 26,
            column: 9
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1zeczi1tpx.s[0];
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  ++cov_1zeczi1tpx.f[0];
  ++cov_1zeczi1tpx.s[1];

  $locationProvider.html5Mode(true).hashPrefix('!');
  ++cov_1zeczi1tpx.s[2];
  $urlRouterProvider.otherwise('/');

  ++cov_1zeczi1tpx.s[3];
  $stateProvider.state('main', {
    url: '/',
    component: 'main'
  });

  ++cov_1zeczi1tpx.s[4];
  $stateProvider.state('dashboard', {
    url: '/dashboard',
    component: 'dashboard',
    resolve: {
      indicators: ["MartyService", function indicators(MartyService) {
        ++cov_1zeczi1tpx.f[1];
        ++cov_1zeczi1tpx.s[5];

        return MartyService.getIndicators();
      }],
      marts: ["indicators", "MartyService", function marts(indicators, MartyService) {
        ++cov_1zeczi1tpx.f[2];
        ++cov_1zeczi1tpx.s[6];

        return MartyService.getMarts();
      }]
    }
  });
}
"use strict";

var cov_1mbtr9eswk = function () {
  var path = "/Users/jvvbsocianova/Projects/socianova/marty/src/constants.js",
      hash = "c01495ca85019af46e14a69508db9397c87607c4",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/jvvbsocianova/Projects/socianova/marty/src/constants.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 34
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1mbtr9eswk.s[0];
angular.module('app').constant("API", "http://apps.preprod.socianova.net/marty/api/public").constant("BASE_HREF", "/marty/");